import React  from "react";
import s from "./SearchInput.module.scss";
import {FontIcon} from "../../FontIcon";

interface ISearchInput {
  searchPlaceholder: string,
  searchString: string,
  onFocusHandler: (event: React.FocusEvent<HTMLInputElement>) => void,
  onBlurHandler: (event: React.FocusEvent<HTMLInputElement>) => void,
  onChangeHandler: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export const SearchInput = React.forwardRef<HTMLInputElement, ISearchInput>(({
  searchPlaceholder,
  onFocusHandler,
  onBlurHandler,
  onChangeHandler,
  searchString
}, inputRef) => {
  return <div className={s.searchContainer}>
    <FontIcon icon={"icon-search"} />
    <input
      ref={inputRef}
      className={s.searchInput}
      type="search"
      value={searchString}
      placeholder={searchPlaceholder}
      onChange={onChangeHandler}
      onFocus={onFocusHandler}
      onBlur={onBlurHandler}
    />
  </div>;
});
